"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ManualRowMove = void 0;
var _manualRowMove = require("./manualRowMove");
exports.PLUGIN_KEY = _manualRowMove.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _manualRowMove.PLUGIN_PRIORITY;
exports.ManualRowMove = _manualRowMove.ManualRowMove;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualRowMove/index.js
// module id = 1467
// module chunks = 0